<template>
  <div class="mournDiv">
    <div>
      <div>
        <div class="festival-ani-box"></div>
        <div>
          <div class="mourn-bg-box">
            <div
              class="mourn-bg"
              :style="'background-image:url(' + templateData[jntTemplateId].bg + ')'"
            ></div>
            <div class="spring-festival-wrap">
              <!-- <div class="lamp-wrap">
                <div class="lamp-left">
                  <img src="../../assets/jnt/denglong.png" alt="" /><img
                    src="../../assets/jnt/denglong1.png"
                    alt=""
                  /><img alt="" />
                </div>
                <div class="lamp-right">
                  <img alt="" /><img src="../../assets/jnt/denglong2.png" alt="" /><img
                    src="../../assets/jnt/denglong3.png"
                    alt=""
                  />
                </div>
              </div> -->
              <!-- <div class="bless-wrap">
                <div class="bless-left">
                  <img src="../../assets/jnt/fu.jpg" alt="" />
                </div>
                <div class="bless-right">
                  <img src="../../assets/jnt/fu1.jpg" alt="" />
                </div>
              </div> -->
              <!-- <div class="couplet-wrap">
                <div class="couplet-left">
                  <img src="../../assets/jnt/duilian1.png" alt="" />
                </div>
                <div class="couplet-right">
                  <img src="../../assets/jnt/duilian2.png" alt="" />
                </div>
              </div>
              <div class="desk-wrap">
                <div class="desk-con">
                  <img src="../../assets/jnt/zhuozi.jpg" alt="" />
                </div>
              </div> -->
              <!-- <div class="desk-hoz-line">
                <div class="incense-wrap">
                  <img src="../../assets/jnt/xianglu.png" alt="" />
                </div>
                <div class="candle-wrap">
                  <div class="candle-left">
                    <img src="../../assets/jnt/lazhu.png" alt="" />
                  </div>
                  <div class="candle-right">
                    <img src="../../assets/jnt/lazhu.png" alt="" />
                  </div>
                </div>
                <div class="fruit-wrap">
                  <div class="fruit-left">
                    <img src="../../assets/jnt/gongguo.png" alt="" />
                  </div>
                  <div class="fruit-right">
                    <img src="../../assets/jnt/gongguo1.png" alt="" />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div>
          <div class="mourn-headimg-box">
            <div
              v-if="$properties(hall.hallCount, 'value') == '2'"
              class="memory-headimg flex double-headimg"
            >
              <div class="memory-headimg-item">
                <div class="headimg">
                  <img :src="hall.firstPhoto" />
                </div>
                <div class="name TextChangeToTwoLines" :style="getColorTxt()">
                  {{ hall.firstName }}
                </div>
                <div class="birth-dear"></div>
              </div>
              <div class="memory-headimg-item">
                <div class="headimg">
                  <img :src="hall.secondPhoto" />
                </div>
                <div class="name TextChangeToTwoLines" :style="getColorTxt()">
                  {{ hall.secondName }}
                </div>
                <div class="birth-dear"></div>
              </div>
            </div>
            <div v-else class="memory-headimg">
              <div class="headimg">
                <img :src="hall.firstPhoto" @click="start()" />
              </div>
              <div class="name pdname" :style="getColorTxt()">{{ hall.title }}</div>
            </div>
            <div class="memory-epipath" :style="getColorTxt()">
              <div class="epipath-item"></div>
              <div class="epipath-item">TA已经离开我们 {{ fmtHallYear() }} 年了</div>
              <div class="epipath-item">
                亲友们已祭拜 {{ hall.browserCount }} 次，已点亮蜡烛 {{ hall.candleCount }} 次
              </div>
              <div class="epipath-item">
                距忌日还有 {{ fmtHallBirthDay() }} 天，距生辰还有 {{ fmtHallDeathDate() }} 天
              </div>
            </div>
          </div>
        </div>
        <div class="mourn-footer-prayer" @click="lightLz">
          <span class="prayer-img"
            ><img src="../../assets/jnt/lz.png" style="width: 1.6rem; height: auto;"
          /></span>
          <div class="prayer-title" @click="addCandle(hall.id)">点亮蜡烛</div>
          <div class="prayer-label">
            已有<span class="tombAllPrayCount">{{ hall.candleCount }}</span
            >人点亮
          </div>
        </div>
        <marqueeY
          :key="new Date().getTime()"
          :jntTemplateId="jntTemplateId"
          :hallGoodsList="hallGoodsList"
          :hall_sacrifice_list="hall_sacrifice_list"
        />
        <marqueeX :msg="msg" :jntTemplateId="jntTemplateId" />
        <div>
          <div class="mourn-right-nav" style="bottom: 6.5rem;">
            <div class="nav-slide">
              <div
                @click="jipin"
                class="slide-item"
                style="border-radius: 50%;
    background: linear-gradient(0deg, #d53d1a, #ffa531);"
              >
                <div class="icon-img icon-wine-img">
                  <img src="../../assets/jnt/jp.png" />
                </div>
                <div class="txt" style="color: rgb(255, 255, 255);">祭品</div>
              </div>
              <div @click="message" class="slide-item" :style="getColor2()">
                <div class="icon-img icon-wine-img">
                  <img src="../../assets/jnt/me.png" />
                </div>
                <div class="txt" style="color: rgb(255, 255, 255);">留言</div>
              </div>
              <div @click="about" class="slide-item" :style="getColor2()">
                <div class="icon-img icon-wine-img">
                  <img src="../../assets/jnt/jj.png" />
                </div>
                <div class="txt" style="color: rgb(255, 255, 255);">简介</div>
              </div>
            </div>
          </div>
          <div class="mourn-footer-nav" style="bottom: 1.2rem; right: 0px; left: auto;">
            <div class="add-tomb-item icon-add-btn flex flex_center">
              <div class="icon-img icon-add-img">
                <img src="../../assets/jnt/mu.png" style="width: 2.18rem; height: 2.18rem;" />
              </div>
              <div @click="goto('/jnt/create')" class="txt" style="color: rgb(255, 255, 255);">
                <div class="txt1">创建纪念馆</div>
                <div class="txt2">为已逝亲人建馆</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="lzFlag">
      <div class="memorial-hall-prayer-wrapper">
        <div class="memorial-hall-prayer-animation-wrapper">
          <div class="memorial-hall-prayer-animation">
            <div class="memorial-hall-prayer-fire">
              <canvas
                width="600"
                height="308"
                style="width: 100%; height: 100%; transform-origin: 0px 0px 0px; "
              ></canvas>
            </div>
            <div class="memorial-hall-prayer-candle">
              <img src="../../assets/jnt/biglz.png" />
            </div>
          </div>
        </div>
        <div class="memorial-hall-prayer-star-only">
          <div class="memorial-hall-prayer-star-1">
            <img src="../../assets/jnt/xg1.png" />
          </div>
          <div class="memorial-hall-prayer-star-2">
            <img src="../../assets/jnt/xg2.png" />
          </div>
        </div>
        <div class="memorial-hall-prayer-text-wrapper">
          <div class="memorial-hall-prayer-text">
            <div class="memorial-hall-prayer-line-one"></div>
            <div class="memorial-hall-prayer-line-two" id="memorial_prayer_count">
              {{ hall.candleCount }}
            </div>
            <div class="memorial-hall-prayer-line-three"></div>
            <div class="memorial-hall-prayer-sep"></div>
            <div class="memorial-hall-prayer-line-four"></div>
            <div class="memorial-hall-prayer-share-btn" @click="share()">
              <div class="memorial-hall-prayer-share-btn-text">传递我的祝福</div>
            </div>
            <div class="memorial-hall-prayer-close-btn" @click="lzFlag = false">
              <img class="memorial-hall-prayer-close-icon" src="../../assets/jnt/lz_close.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="fireFlag || firesFlag"
      style="background: #000000bf;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;"
    >
      <x-fires v-if="firesFlag" :imgList="imgList"> </x-fires>
      <x-fire v-if="fireFlag" :imgList="imgList"> </x-fire>
    </div>
    <!-- 单个祭品 -->
    <!-- <div id="iframe-box" class="iframe-box">
      <div class="iframe-img">
        <div class="styles_particles__5dxGv">
          <div class="styles_wrapper__3KXDn" style="transform: translateY(-120px);">
            <div class="styles_content__1Phom" style="transform: translateY(120px);">
              <img src="../../assets/jnt/lz_close.png" />
            </div>
          </div>
          <canvas class="styles_canvas__1krxf" style="" width="420" height="420"></canvas>
        </div>
      </div>
    </div> -->
    <!-- 单个祭品 -->
    <!-- 1 -->
    <div v-if="jntTemplateId == 0" class="sky-stars" style="height: 667px;">
      <div class="star yellow2"></div>
      <div class="star yellow"></div>
    </div>
    <!-- 1 -->
    <!-- 2 -->
    <div v-if="jntTemplateId == 1" class="memory-ani-main">
      <div class="sky-lamp-wrap">
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
        <div class="sky-lamp-item"></div>
      </div>
      <div class="river-lamp-wrap">
        <div class="river-lamp-item lamp-type1"></div>
        <div class="river-lamp-item lamp-type1"></div>
        <div class="river-lamp-item lamp-type2"></div>
        <div class="river-lamp-item lamp-type2"></div>
        <div class="river-lamp-item lamp-type1"></div>
        <div class="river-lamp-item lamp-type1"></div>
        <div class="river-lamp-item lamp-type1"></div>
        <div class="river-lamp-item lamp-type2"></div>
      </div>
    </div>
    <!--  -->
    <!-- 3 -->
    <div v-if="jntTemplateId == 2" class="autumn-wrap">
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
      <div class="leaf leaf-type1"></div>
      <div class="leaf leaf-type2"></div>
    </div>
    <!-- 3 -->
    <!-- 4 -->
    <div v-if="jntTemplateId == 3" class="memory-ani-main">
      <div class="duanwu-leaf">
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
        <div class="leaf leaf-type1"></div>
        <div class="leaf leaf-type2"></div>
      </div>
      <div class="rice-pudding">
        <img src="../../assets/jnt/jntbg/4/1.png" alt="" />
      </div>
      <div>
        <div class="duanwu-boat1">
          <img src="../../assets/jnt/jntbg/4/2.png" alt="" />
        </div>
        <div class="duanwu-boat2">
          <img src="../../assets/jnt/jntbg/4/3.png" alt="" />
        </div>
      </div>
      <div class="cloud-wrap">
        <div class="cloud1">
          <img src="../../assets/jnt/jntbg/4/4.png" alt="" />
        </div>
        <div class="cloud2">
          <img src="../../assets/jnt/jntbg/4/5.png" alt="" />
        </div>
        <div class="cloud3">
          <img src="../../assets/jnt/jntbg/4/6.png" alt="" />
        </div>
        <div class="cloud4">
          <img src="../../assets/jnt/jntbg/4/7.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 4 -->
    <!-- 5 -->
    <div v-if="jntTemplateId == 4" class="summer-wrap">
      <div class="sum-leaf">
        <img src="../../assets/jnt/jntbg/5/1.png" alt="" />
      </div>
      <div class="sum-boat">
        <img src="../../assets/jnt/jntbg/5/2.png" alt="" />
      </div>
    </div>
    <!-- 5 -->
    <!-- 6 -->
    <div v-if="jntTemplateId == 5" class="winter-wrap">
      <div class="small-snow">
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
      </div>
      <div class="big-snow">
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
        <div class="snow-item"></div>
      </div>
    </div>
    <!-- 6 -->
  </div>
</template>

<script>
import bus from '../../common/bus'
import MarqueeY from './common/MarqueeY'
import MarqueeX from './common/MarqueeX'
import XFire from './common/Fire'
import XFires from './common/Fires'
import moment from 'moment'
export default {
  name: 'mourn',
  components: {
    MarqueeY,
    MarqueeX,
    XFire,
    XFires,
  },
  imgList: [],
  props: ['jntTemplateId', 'myTemplateId', 'hall_sacrifice_list', 'hallGoodsList', 'msg'],
  data() {
    return {
      firesFlag: false,
      fireFlag: false,
      fire: '',
      templateData: [
        {
          bg: require('../../assets/jnt/jntbg/1/bg.png'),
        },
        {
          bg: require('../../assets/jnt/jntbg/2/bg.jpg'),
        },
        {
          bg: require('../../assets/jnt/jntbg/3/bg.jpg'),
        },
        {
          bg: require('../../assets/jnt/jntbg/4/bg.jpg'),
        },
        {
          bg: require('../../assets/jnt/jntbg/5/bg.jpg'),
        },
        {
          bg: require('../../assets/jnt/jntbg/6/bg.jpg'),
        },
      ],
      //bgImg: require('../../assets/jnt/jntbg/1/bg.jpg'),
      lzFlag: false,
      id: null,
      type: null,
      hall: {
        id: null,
        hallCount: null,
        title: null,
        content: null,
        firstName: null,
        firstPhoto: null,
        firstBirthDate: null,
        firstDeathDate: null,
        secondName: null,
        secondPhoto: null,
        secondBirthDate: null,
        secondDeathDate: null,
        browserCount: null,
        candleCount: null,
      },
    }
  },
  watch: {
    fireFlag() {
      if (!this.fireFlag) {
        bus.$emit('queryHallCandle', '')
      }
    },
    firesFlag() {
      if (!this.firesFlag) {
        bus.$emit('queryHallCandle', '')
      }
    },
    lzFlag() {
      if (!this.lzFlag) {
        bus.$emit('queryHallCandle', '')
      }
    },
  },
  created() {
    var params = this.$route.params
    this.id = params.id
    this.type = params.type
    bus.$off('fire')
    bus.$on('fire', msg => {
      if (msg.type == 1) {
        this.start()
        this.imgList = msg.data
      } else {
        this.starts()
        this.imgList = msg.data
      }
    })
  },
  mounted() {
    // var visited = this.$getVisited('HallInfo_' + this.id)
    // if (visited == 1) {
    //   this.$plus('HallInfo', { id: this.id }, ['browserCount'])
    // }
    // this.queryHallOne()
    //this.queryMemHallSacrifice()
    this.mournInit()
  },
  methods: {
    mournInit() {
      var visited = this.$getVisited('HallInfo_' + this.id)
      if (visited == 1) {
        this.$plus('HallInfo', { id: this.id }, ['browserCount'])
      }
      this.queryHallOne()
    },
    share() {
      this.lzFlag = false
      bus.$emit('share', 'open')
    },
    starts() {
      this.firesFlag = true

      setTimeout(() => {
        this.firesFlag = false
      }, 5000)
    },
    start() {
      this.fireFlag = true

      setTimeout(() => {
        this.fireFlag = false
      }, 4000)
    },
    getGoodsName(id) {
      let _name = ''
      this.hallGoodsList.map(item => {
        if (item.id == id) {
          _name = item.proName
        }
      })
      return _name
    },
    getGoodsImg(id) {
      let _img = ''
      this.hallGoodsList.map(item => {
        if (item.id == id) {
          _img = item.firstPhoto
        }
      })
      return _img
    },
    getColorTxt() {
      let _css = 'color: rgb(255, 255, 255);'
      if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
        _css = 'color:#333;'
      }
      return _css
    },

    getColor2() {
      let _css = 'background: rgba(255, 255, 255, 0.2);'
      if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
        _css = 'background: rgba(0, 0, 0, 0.4);'
      }
      return _css
    },
    getColor() {
      let _css = 'background: rgba(255, 255, 255, 0.2); color: rgb(255, 255, 255);'
      if (this.jntTemplateId == 2 || this.jntTemplateId == 3 || this.jntTemplateId == 5) {
        _css = 'background: #0006; color: rgb(255, 255, 255);'
      }
      return _css
    },
    queryHallOne() {
      var that = this
      var params = this.$route.params
      var id = params['id']
      this.$queryOne('HallInfo', { id: id }, this.hall, function(res) {
        that.$fill(that.hall, res['data'])
      })
    },
    queryCandleList() {},
    // queryMemHallSacrifice() {
    //   var that = this
    //   this.$queryAll(
    //     'MemHallSacrifice',
    //     {},
    //     ['id,proSacrifice.firstPhoto,proSacrifice.proName,myProfile.nickname'],
    //     function(res) {
    //       that.$fill(that.hall_sacrifice_list, res['data'])
    //     }
    //   )
    // },
    addCandle(hallId) {
      var visited = this.$getVisited('HallInfo_Candle_' + this.id)
      if (visited == 1) {
        var that = this
        this.$submit('/api/hallhistory/addCandle', {
          hallId: hallId,
          myId: this.$store.getters.userId,
        })
        this.$plus('HallInfo', { id: hallId }, ['candleCount'], function() {
          that.queryHallOne()
        })
      }
    },
    fmtHallYear() {
      if (this.hall.firstDeathDate) {
        var startDate = moment(this.hall.firstDeathDate, 'YYYY-MM-DD HH:mm:ss')
        var endDate = moment(new Date())
        var years = endDate.diff(startDate, 'year')
        return years
      }
      return ''
    },
    fmtHallBirthDay() {
      if (this.hall.firstBirthDate) {
        var startDate = moment(this.hall.firstBirthDate, 'YYYY-MM-DD HH:mm:ss')
        var endDate = moment(new Date())
        var years = endDate.diff(startDate, 'year')
        var days = endDate.diff(startDate.add(years, 'years'), 'day')
        return days
      }
      return ''
    },
    fmtHallDeathDate() {
      if (this.hall.firstBirthDate) {
        var startDate = moment(this.hall.firstDeathDate, 'YYYY-MM-DD HH:mm:ss')
        var endDate = moment(new Date())
        var years = endDate.diff(startDate, 'year')
        var days = endDate.diff(startDate.add(years, 'years'), 'day')
        return days
      }
      return ''
    },
    lightLz() {
      this.lzFlag = true
    },
    goto(str) {
      this.$router.push({ path: str })
    },
    jipin() {
      bus.$emit('jipin', '')
    },
    message() {
      // this.queryHallMessage()
      bus.$emit('messageList', '')
    },
    about() {
      bus.$emit('about', '')
    },
    //
  },
}
</script>

<style>
@keyframes ani-down {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  to {
    opacity: 0;
    top: 667px;
  }
}

@keyframes ani-left-move1 {
  0% {
    left: 80px;
  }
  to {
    left: 60px;
  }
}

@keyframes ani-left-move2 {
  0% {
    left: 320px;
  }
  to {
    left: 240px;
  }
}

@keyframes ani-left-move3 {
  0% {
    right: 0;
  }
  to {
    right: 200px;
  }
}

@keyframes ani-right-move1 {
  0% {
    left: 100px;
  }
  to {
    left: 280px;
  }
}
.relation_tip {
  position: fixed;
  bottom: 4.825rem;
  left: 0;
  width: 100%;
  height: 55px;
  background: rgba(0, 0, 0, 0.7);
  padding: 0 10px;
  -webkit-align-items: center;
  align-items: center;
  z-index: 200;
}
.relation_tip .icon-home {
  background: url(../../assets/jnt/home1.png);
  background-size: 100% 100%;
  height: 22px;
  width: 22px;
}
.relation_tip .txt {
  color: #fff;
  margin-left: 10px;
  font-size: 1.2rem;
  padding-top: 2px;
}
.relation_tip .icon-close {
  background: url(../../assets/jnt/close.png);
  background-size: 100% 100%;
  height: 14px;
  width: 14px;
  position: absolute;
  right: 2.5rem;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
.mourn-head-left,
.mourn-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.mourn-head-left {
  left: 0;
}
.mourn-head-left,
.mourn-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.mourn-head .left-back {
  height: 2.5rem;
  width: 2.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.mourn-head .left-back .back-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/jt1.png) no-repeat;
  background-size: 100% 100%;
}
.mourn-head .left-home {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-left: 10px;
}
.mourn-head .left-home .home-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/home2.png) no-repeat;
  background-size: 100% 100%;
  margin-top: -1px;
  margin-left: 1px;
}
.center-info .follow-icon-wrap {
  display: flex;
  display: -webkit-flex;
  border-radius: 1.272rem !important;
  width: 3.6rem;
  height: 2.5rem;
}
.center-info .follow-btn,
.center-info .follow-icon-wrap {
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
}
.center-info .follow-no {
  background: url(../../assets/jnt/sc.png) no-repeat;
  background-size: 100% 100%;
}
.center-info .follow-icon {
  width: 20px;
  height: 20px;
}
.mourn-head-right {
  right: 0;
}
.mourn-head-left,
.mourn-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.mourn-head-left,
.mourn-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.mourn-head .music_play {
  -webkit-animation: play 10s linear infinite;
  animation: play 10s linear infinite;
}
.mourn-head .music-wrap {
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  margin-right: 1rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.mourn-head .music-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/music.png) no-repeat;
  background-size: 100% 100%;
}
.mourn-head .right-share {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
  margin-right: 1rem;
}
.mourn-head .right-menu,
.mourn-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.mourn-head .right-share .share-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/share.png) no-repeat;
  background-size: 100% 100%;
}
.mourn-head .right-menu,
.mourn-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.mourn-head .right-menu {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.mourn-head .right-menu .menu-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/w.png) no-repeat;
  background-size: 100% 100%;
}
.mournDiv .mourn-bg {
  background-size: 100% 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 100%;
  height: 100%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}

.spring-festival-wrap {
  width: 100%;
  z-index: 10;
}
.spring-festival-wrap .lamp-wrap {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
}
.lamp-wrap {
  width: 100%;
  height: 1rem;
  position: fixed;
  bottom: -4rem;
}
.spring-festival-wrap .lamp-wrap .lamp-left img:first-child {
  left: 4vw;
  z-index: 5;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-left img:nth-child(2) {
  left: 10.4vw;
  z-index: 4;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-left img:nth-child(3) {
  left: 16.4vw;
  z-index: 3;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-right img:first-child {
  right: 16.4vw;
  z-index: 3;
}
.spring-festival-wrap .bless-wrap .bless-left {
  left: 1.6vw;
}
.spring-festival-wrap .bless-wrap .bless-left,
.spring-festival-wrap .bless-wrap .bless-right {
  width: 16vw;
  position: fixed;
  top: 18.5vw;
}
.spring-festival-wrap .bless-wrap .bless-left img,
.spring-festival-wrap .bless-wrap .bless-right img {
  width: 100%;
}
.spring-festival-wrap .bless-wrap .bless-right {
  right: 1.6vw;
}
.spring-festival-wrap .bless-wrap .bless-left,
.spring-festival-wrap .bless-wrap .bless-right {
  width: 16vw;
  position: fixed;
  top: 18.5vw;
}
.spring-festival-wrap .bless-wrap .bless-left img,
.spring-festival-wrap .bless-wrap .bless-right img {
  width: 100%;
}
.spring-festival-wrap .couplet-wrap .couplet-left {
  left: 4vw;
}
.spring-festival-wrap .couplet-wrap .couplet-left,
.spring-festival-wrap .couplet-wrap .couplet-right {
  width: 11.467vw;
  position: fixed;
  top: 35.07vw;
}
.spring-festival-wrap .couplet-wrap .couplet-left img,
.spring-festival-wrap .couplet-wrap .couplet-right img {
  width: 100%;
}

.spring-festival-wrap .couplet-wrap .couplet-right {
  right: 4vw;
}
.spring-festival-wrap .couplet-wrap .couplet-left,
.spring-festival-wrap .couplet-wrap .couplet-right {
  width: 11.467vw;
  position: fixed;
  top: 35.07vw;
}
.spring-festival-wrap .couplet-wrap .couplet-left img,
.spring-festival-wrap .couplet-wrap .couplet-right img {
  width: 100%;
}
.spring-festival-wrap .desk-wrap {
  position: fixed;
  bottom: 23.6vw;
  left: 50%;
  transform: translateX(-50%);
}
.spring-festival-wrap .desk-wrap .desk-con {
  width: 83.2vw;
}
.spring-festival-wrap .desk-wrap .desk-con img {
  width: 100%;
  display: block;
}
.spring-festival-wrap .desk-hoz-line {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 63.667vw;
}
.spring-festival-wrap .desk-hoz-line .incense-wrap {
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 21.33vw;
  z-index: 5;
}

.spring-festival-wrap .desk-hoz-line .incense-wrap img {
  width: 100%;
}
.spring-festival-wrap .desk-hoz-line .candle-wrap {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 37.6vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 4;
}
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-left,
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-right {
  width: 10.4vw;
}
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-left img,
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-right img {
  width: 100%;
}
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-left,
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-right {
  width: 10.4vw;
}
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-left img,
.spring-festival-wrap .desk-hoz-line .candle-wrap .candle-right img {
  width: 100%;
}
.spring-festival-wrap .desk-hoz-line .fruit-wrap {
  position: absolute;
  bottom: 1vw;
  left: 50%;
  transform: translateX(-50%);
  width: 66.13vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 3;
}
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-left,
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-right {
  width: 13.867vw;
}
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-left img,
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-right img {
  width: 100%;
}
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-left,
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-right {
  width: 13.867vw;
}
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-left img,
.spring-festival-wrap .desk-hoz-line .fruit-wrap .fruit-right img {
  width: 100%;
}
.mourn-headimg-box {
  position: fixed;
  left: 50%;
  top: 12rem;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100vw;
  z-index: 10;
}
.mourn-headimg-box .mourn-headimg {
  width: 100%;
  z-index: 10;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin: 0 auto;
}
.mourn-headimg-box .mourn-headimg .headimg {
  width: 7.65rem;
  margin: 0 auto;
  background: url(../../assets/jnt/k.png) no-repeat;
  background-size: 100% 100%;
  box-shadow: 0 2px 6px 0 rgb(44 14 0 / 50%);
  position: relative;
  height: 9.15rem;
  padding: 0.4rem;
}
.mourn-headimg-box .mourn-headimg .headimg img {
  width: 84.3%;
  border: 3px solid #fff;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 72%;
  position: absolute;
  left: 0.4rem;
  height: 87.1%;
  vertical-align: middle;
  -o-object-fit: cover;
  object-fit: cover;
}
.mourn-headimg-box .mourn-headimg .pdname {
  padding-left: 5.2rem;
  padding-right: 5.2rem;
}
.mourn-headimg-box .mourn-headimg .name {
  text-align: center;
  padding-top: 1rem;
  font-size: 1.55rem;
  line-height: 26px;
}
.mourn-footer-prayer {
  position: fixed;
  bottom: 1.2rem;
  left: 10px;
  width: 13.636rem;
  height: 4.272rem;
  padding-left: 0.5rem;
  color: #983900;
  display: inline-block;
  text-align: center;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  background: url(../../assets/jnt/hlz.png) no-repeat;
  background-size: 100% 100%;
  z-index: 9;
  box-sizing: border-box;
}
.mourn-footer-prayer .prayer-img {
  position: absolute;
  top: 8px;
  left: 15px;
}
.mourn-footer-prayer .prayer-img img {
  width: 20px;
  height: 29px;
}
.mourn-footer-prayer .prayer-title {
  font-size: 1.363rem;
  font-family: PingFangSC-Medium;
  color: #983900;
  font-weight: 700;
}
.mourn-footer-prayer .prayer-label {
  word-break: keep-all;
  font-size: 1.1rem;
  margin-top: -0.2rem;
  padding-left: 0.5rem;
  /* padding-top: 0.2rem; */
}
.mourn-pray-list {
  width: 85%;
  height: 20.08rem;
  margin: 0 auto;
  position: fixed;
  bottom: 7.88rem;
  z-index: 10;
  overflow: hidden;
  padding-top: 20px;
  padding-left: 15px;
}
.rowup-jrq588bltd {
  -webkit-animation: 127250ms rowupjrq588bltd linear infinite normal;
  animation: 127250ms rowupjrq588bltd linear infinite normal;
}

.mourn-pray-list .mourn-pray-record {
  align-items: center;
  display: block;
}
.mourn-pray-record .mourn-pray-record_item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 24px;
  padding: 0 0.3rem;
  margin-bottom: 1.46rem;
  width: fit-content;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  line-height: 1.35rem;
}

.mourn-pray-record_item .avatar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid #e4803c;
}

.mourn-pray-record_item .info {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-left: 0.6rem;
  padding-top: 0.1rem;
}
.mourn-pray-record_item .info .name {
  color: #fff;
  font-size: 0.9rem;
}
.mourn-pray-record_item .info .goods-name {
  color: #f1a524;
  font-size: 0.9rem;
}
.mourn-pray-record_item .pray-img {
  width: 35px;
  position: relative;
  margin-left: 1.44rem;
  margin-right: 0.6rem;
}
.mourn-pray-record_item .pray-img img {
  width: 100%;
  position: absolute;
  top: -2.45rem;
}

.inner-box {
  background-color: #fff;
  min-height: 100px;
  position: relative;
}
.inner-box .inner-box-txt {
  height: 4.272rem;
  line-height: 4.272rem;
  text-align: center;
  font-size: 1.454rem;
  color: #333;
  position: relative;
  background-color: #f7f7f7;
}
.inner-box-radius {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.pray_goods_box {
  width: auto;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;
}
.pray_goods_box .goods_nav {
  list-style: none;
  font-size: 1.3rem;
  margin-bottom: 1.8rem;
  background: #f7f7f7;
  width: 80px;
  box-sizing: border-box;
}

.inner-box-close {
  width: 1.18rem;
  height: 1.18rem;
  background: url(../../assets/jnt/c1.png) no-repeat;
  background-size: 100% 100%;
  z-index: 11;
  display: inline-block;
  cursor: pointer;
}
.inner-box-close {
  position: absolute;
  top: 14px;
  right: 14px;
}
.inner-box-close__right {
  right: 1.5rem;
}
.mt-offcanvas.active ~ .mt-offcanvas-mask {
  visibility: visible;
  z-index: 1000;
}
.mt-offcanvas-bottom__show ~ .mt-offcanvas-mask,
.mt-offcanvas-center__show ~ .mt-offcanvas-mask,
.mt-offcanvas-left__show ~ .mt-offcanvas-mask,
.mt-offcanvas-right__show ~ .mt-offcanvas-mask,
.mt-offcanvas-top__show ~ .mt-offcanvas-mask {
  opacity: 0.6;
}
.mt-offcanvas-mask {
  position: fixed;
  z-index: -1;
  visibility: hidden;
  top: 0;
  bottom: 0;
  width: 100%;
  margin: 0 auto;
  background-color: #000;
  opacity: 0;
  transition: opacity 0.4s linear;
  -webkit-transition: opacity 0.4s linear;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
.mt-offcanvas.active {
  visibility: visible;
  z-index: 2000;
}
.mt-offcanvas {
  position: fixed;
  z-index: -1;
  visibility: hidden;
  margin: 0 auto;
  min-height: 1em;
  min-width: 1em;
}
.mourn-head-left,
.mourn-head-right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.mourn-head-left,
.mourn-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}

.mourn-head-left,
.mourn-head-right {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.mourn-head-left,
.mourn-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.spring-festival-wrap .lamp-wrap .lamp-right img:first-child {
  right: 16.4vw;
  z-index: 3;
}

.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-right img:first-child {
  right: 16.4vw;
  z-index: 3;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-right img:nth-child(2) {
  right: 10.4vw;
  z-index: 4;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.spring-festival-wrap .lamp-wrap .lamp-right img:nth-child(3) {
  right: 4vw;
  z-index: 5;
}
.spring-festival-wrap .lamp-wrap .lamp-left img,
.spring-festival-wrap .lamp-wrap .lamp-right img {
  position: fixed;
  top: 0;
  width: 11.466vw;
}
.mourn-right-nav {
  position: fixed;
  right: 1rem;
  bottom: 1.3rem;
  z-index: 10;
}
.mourn-right-nav .nav-slide {
  border-radius: 2.82667rem;
  overflow: hidden;
  z-index: 3;
  /* background: rgba(0, 0, 0, 0.4); */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1.8rem 1px;
}
.mourn-right-nav .nav-slide .slide-item:first-child {
  margin-top: 0;
}
.mourn-right-nav .nav-slide .slide-item {
  width: 5rem;
  height: 5rem;
  text-align: center;
  margin-top: 2.2rem;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
}
.mourn-right-nav .nav-slide .slide-item .icon-img {
  width: 2.272rem;
  height: 2.272rem;
  margin: auto;
  margin-top: 0.3rem;
}
.mourn-right-nav .nav-slide .slide-item img {
  width: 100%;
  height: 100%;
}
.mourn-right-nav .nav-slide .slide-item .txt {
  font-size: 1.09rem;
  /* padding-top: 0.2rem; */
  box-sizing: border-box;
}
.mourn-footer-nav {
  position: fixed;
  bottom: 0.8rem;
  left: 15.6rem;
  z-index: 9;
}
.mourn-footer-nav .add-tomb-item {
  width: 13.8rem;
  height: 4.272rem;
  box-sizing: border-box;
  background: url(../../assets/jnt/an.png) no-repeat;
  background-size: 100% 100%;
  padding: 0 1.1rem;
}
.mourn-footer-nav .icon-add-btn {
  margin-right: 1rem;
}
.flex_center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.mourn-footer-nav .add-tomb-item .icon-add-img {
  margin-right: 0.45rem;
}
.mourn-footer-nav .icon-add-btn img,
.mourn-footer-nav .icon-share-btn img,
.mourn-right-nav .icon-msg-btn img,
.mourn-right-nav .icon-package-btn img,
.mourn-right-nav .icon-pray-btn img,
.mourn-right-nav .icon-share-btn img {
  width: 2.4rem;
}
.mourn-footer-nav .add-tomb-item .txt1 {
  font-size: 1.363rem;
  font-weight: 700;
}
.mourn-footer-nav .add-tomb-item .txt2 {
  font-size: 1.1rem;
  /* padding-top: 0.2rem; */
}
.head-tabNav-wrap {
  position: fixed;
  top: 5.68rem;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  width: 10.91rem;
  z-index: 99;
}
.head-tabNav-wrap .tabNav-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item.active,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeBlack,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeWhite {
  opacity: 1;
  filter: alpha(opacity=100);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  background-color: #fff;
}
.head-tabNav-wrap .tabNav-con .activeBlack:after,
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 2rem;
  height: 3px;
}
.memorial-hall-prayer-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  z-index: 201;
  background-image: url(../../assets/jnt/lzbg.png);
  background-size: 100%;
  overflow: hidden;
}
.memorial-hall-prayer-candle,
.memorial-hall-prayer-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.memorial-hall-prayer-animation-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.memorial-hall-prayer-animation {
  position: relative;
  top: 2.24rem;
  -webkit-animation: 1s candlefire cubic-bezier(0.32, 0.94, 0.6, 1);
  animation: 1s candlefire cubic-bezier(0.32, 0.94, 0.6, 1);
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-fire {
  position: relative;
  width: 100%;
  z-index: 0;
  top: 1rem;
}

canvas {
  display: inline-block;
}
.memorial-hall-prayer-candle {
  -webkit-animation: 2s candle linear;
  animation: 2s candle linear;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-star-only {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.memorial-hall-prayer-star-1 {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  animation: starFlick1 2s cubic-bezier(0.48, 0.04, 0.52, 0.96) 1s infinite;
  -webkit-animation: starFlick1 2s cubic-bezier(0.48, 0.04, 0.52, 0.96) 1s infinite;
}
.memorial-hall-prayer-star-1 > img {
  position: relative;
  top: 7.8rem;
}
.memorial-hall-prayer-star-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  animation: starFlick2 2s cubic-bezier(0.48, 0.04, 0.52, 0.96) infinite;
  -webkit-animation: starFlick2 2s cubic-bezier(0.48, 0.04, 0.52, 0.96) infinite;
}
.memorial-hall-prayer-star-2 > img {
  position: relative;
  top: 7.8rem;
}
.memorial-hall-prayer-text-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}
.memorial-hall-prayer-text {
  text-align: center;
  position: relative;
  top: 46%;
  z-index: 2;
  color: #fff;
  height: 50%;
}
.memorial-hall-prayer-line-one {
  position: relative;
  width: 8.8rem;
  height: 1.86rem;
  margin: 0 auto;
  background-image: url(../../assets/jnt/lztxt1.png);
  background-size: 100%;
  background-repeat: no-repeat;
  -webkit-animation: 1s one cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s one cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-line-two {
  position: relative;
  top: 1.7%;
  color: #fee300;
  font-size: 2.98rem;
  line-height: 3.18rem;
  font-family: DINPro-Light;
  letter-spacing: 0.034rem;
  -webkit-animation: 1s two cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s two cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-line-three {
  position: relative;
  width: 5.48rem;
  height: 2.36rem;
  margin: 0 auto;
  top: 4%;
  background-image: url(../../assets/jnt/lztxt.png);
  background-size: 100%;
  background-repeat: no-repeat;
  -webkit-animation: 1s three cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s three cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-sep {
  position: relative;
  padding-top: 10.3%;
  width: 17.92rem;
  height: 0.02rem;
  border-bottom: 0.5px solid hsla(0, 0%, 100%, 0.5);
  display: inline-block;
  -webkit-animation: 1s sep cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s sep cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-line-four {
  position: relative;
  top: 7.8%;
  width: 18.14rem;
  height: 2.36rem;
  margin: 0 auto;
  letter-spacing: 0.1rem;
  font-size: 0.36rem;
  line-height: 0.36rem;
  background-image: url(../../assets/jnt/gaowei.png);
  background-size: 100%;
  background-repeat: no-repeat;
  -webkit-animation: 1s four cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s four cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-share-btn {
  position: relative;
  top: 11%;
  width: 14.96rem;
  height: 6.2rem;
  margin: 0 auto;
  background-size: cover;
  background-image: url(../../assets/jnt/share1.png);
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  color: #d63100;
  font-weight: 700;
  -webkit-animation: 1s share cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s share cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-share-btn-text {
  position: relative;
  font-size: 1.42rem;
  margin-left: 2.18rem;
}
.memorial-hall-prayer-close-btn {
  position: relative;
  margin: 0 auto;
  bottom: -17%;
  -webkit-animation: 1s close cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  animation: 1s close cubic-bezier(0.32, 0.94, 0.6, 1) 1.2s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
.memorial-hall-prayer-close-btn > img {
  width: 2.54rem;
  height: 2.54rem;
  margin: 0 auto;
}

.memory-headimg .double-headimg {
  width: 30vw;
}
.memory-headimg {
  width: 100%;
  z-index: 10;
  justify-content: center;
  margin: 0 auto;
}
.memory-headimg .memory-headimg-item {
  margin-left: 10px;
  margin-right: 10px;
}
.memory-headimg .headimg {
  width: 7.27rem;
  height: 9.09rem;
  margin: 0 auto;
  background: url(../../assets/jnt/kuang.jpg) no-repeat;
  background-size: 100% 100%;
  box-shadow: 0 2px 6px 0 rgb(44 14 0 / 50%);
  position: relative;
  box-sizing: border-box;
}
.memory-headimg .headimg img {
  width: 5.91rem;
  height: 7.73rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 72%;
  position: absolute;
  left: 0.68rem;
  top: 0.68rem;
  vertical-align: middle;
  -o-object-fit: cover;
  object-fit: cover;
}
.memory-headimg .name {
  text-align: center;
  padding-top: 1rem;
  font-size: 1.46rem;
  line-height: 26px;
}
.TextChangeToTwoLines {
  -webkit-line-clamp: 2 /*! autoprefixer: off*/;
}
.TextChangeToOneLines,
.TextChangeToTwoLines {
  display: -webkit-box !important;
  overflow: hidden;
  word-break: break-all;
  -webkit-box-orient: vertical;
}
.sky-stars {
  overflow: hidden;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.sky-stars .star {
  display: block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
  top: 60px;
  left: 400px;
  position: relative;
  transform-origin: 100% 0;
  animation: star-ani 4s linear infinite;
  box-shadow: 0 0 5px 5px hsla(0, 0%, 100%, 0.3);
  opacity: 0;
  z-index: 2;
  animation-delay: 3s;
}

.sky-stars .star:after {
  content: '';
  display: block;
  top: 0;
  left: 4px;
  border: 0 solid #fff;
  border-width: 0 90px 2px;
  border-color: transparent transparent transparent hsla(0, 0%, 100%, 0.3);
  transform: rotate(-45deg) translate3d(1px, 3px, 0);
  box-shadow: 0 0 1px 0 hsla(0, 0%, 100%, 0.1);
  transform-origin: 0 100%;
  animation: shooting-ani 4s infinite ease-out;
}

.sky-stars .pink {
  top: 30px;
  left: 395px;
  background: #ff5a99;
}

.sky-stars .pink,
.sky-stars .pink:after {
  animation-delay: 5s;
  -webkit-animation-delay: 5s;
  -moz-animation-delay: 5s;
}

.sky-stars .pink:after {
  border-color: transparent transparent transparent #ff5a99;
}

.sky-stars .blue {
  top: 35px;
  left: 432px;
  background: cyan;
  animation-delay: 7s;
  -webkit-animation-delay: 7s;
  -moz-animation-delay: 7s;
}

.sky-stars .blue:after {
  border-color: transparent transparent transparent #1c82c3;
  animation-delay: 12s;
  animation-delay: 7s;
}

.sky-stars .yellow {
  top: 50px;
  left: 530px;
  background: #ffcd5c;
  animation-delay: 8s;
}

.sky-stars .yellow:after {
  border-color: transparent transparent transparent #ffcd5c;
  animation-delay: 8s;
}

.sky-stars .yellow2 {
  top: 30px;
  left: 200px;
  background: #ffcd5c;
  animation-delay: 3s;
}

.sky-stars .yellow2:after {
  border-color: transparent transparent transparent #ffcd5c;
  animation-delay: 3s;
}

@keyframes star-ani {
  0% {
    opacity: 0;
    transform: scale(0.5) translateZ(0);
    -webkit-transform: scale(0.5) translateZ(0);
    -moz-transform: scale(0.5) translateZ(0);
  }
  50% {
    opacity: 0.8;
    transform: translate3d(-200px, 200px, 0);
    -webkit-transform: translate3d(-200px, 200px, 0);
    -moz-transform: translate3d(-200px, 200px, 0);
  }
  to {
    opacity: 0;
    transform: scale(1.2) translate3d(-400px, 400px, 0);
    -webkit-transform: scale(1.2) translate3d(-400px, 400px, 0);
    -moz-transform: scale(1.2) translate3d(-400px, 400px, 0);
  }
}
.memory_main .memory-epipath {
  color: #dadada;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 15px;
  padding: 0 3.5rem;
}
/* 湖面孔明灯 */

.sky-lamp-wrap .sky-lamp-item {
  width: 23px;
  height: 26px;
  background: url(../../assets/jnt/jntbg/2/3.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  opacity: 0.8;
}

.sky-lamp-wrap .sky-lamp-item:first-child {
  right: -18vw;
  top: 60%;
  animation: lamp1-fly 22s ease-in 3s infinite;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(2) {
  right: -7vw;
  top: 63%;
  animation: lamp2-fly 21s ease-in 2.5s infinite;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(3) {
  right: -17vw;
  top: 65%;
  animation: lamp3-fly 20s ease-in 12s infinite;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(4) {
  right: -11vw;
  top: 53%;
  animation: lamp4-fly 22s ease-in 16s infinite;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(5) {
  right: -12vw;
  top: 53%;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(6) {
  left: -11vw;
  top: 53%;
  animation: lamp6-fly 26s ease-in 4s infinite;
  transform: rotate(20deg);
}

.sky-lamp-wrap .sky-lamp-item:nth-child(7) {
  left: -12vw;
  top: 69%;
}

.sky-lamp-wrap .sky-lamp-item:nth-child(8) {
  left: -9vw;
  top: 60%;
  animation: lamp8-fly 20s ease-in 7s infinite;
  transform: rotate(13deg);
}

.sky-lamp-wrap .sky-lamp-item:nth-child(9) {
  left: -9vw;
  top: 64%;
  animation: lamp9-fly 23s ease-in 13s infinite;
  transform: rotate(22deg);
}

.sky-lamp-wrap .sky-lamp-item:nth-child(10) {
  left: -9vw;
  top: 63%;
  animation: lamp10-fly 24s ease-in 18s infinite;
  transform: rotate(18deg);
}

.sky-lamp-wrap .sky-lamp-item:nth-child(11) {
  left: -9vw;
  top: 59%;
  animation: lamp11-fly 26s ease-in 5s infinite;
  transform: rotate(18deg);
}

.sky-lamp-wrap .sky-lamp-item:nth-child(12) {
  right: -9vw;
  top: 55%;
  animation: lamp12-fly 28s ease-in 8s infinite;
}

@keyframes lamp1-fly {
  0% {
    right: -18vw;
    top: 60%;
    transform: scale(1);
  }
  35% {
    right: 10vw;
    top: 50%;
    transform: scale(0.9);
  }
  95% {
    right: 14vw;
    top: 1%;
    transform: scale(0.2);
  }
  to {
    right: 14vw;
    top: -5%;
    transform: scale(0);
  }
}

@keyframes lamp2-fly {
  0% {
    right: -7vw;
    top: 63%;
    transform: scale(1);
  }
  36% {
    right: 7vw;
    top: 40%;
    transform: scale(0.8);
  }
  95% {
    right: 9vw;
    top: 3%;
    transform: scale(0.1);
  }
  to {
    right: 9vw;
    top: -5%;
    transform: scale(0);
  }
}

@keyframes lamp3-fly {
  0% {
    right: -17vw;
    top: 65%;
    transform: scale(1);
  }
  40% {
    right: 26vw;
    top: 50%;
    transform: scale(0.9);
  }
  95% {
    right: 26vw;
    top: 3%;
    transform: scale(0.1);
  }
  to {
    right: 26vw;
    top: -5%;
    transform: scale(0);
  }
}

@keyframes lamp4-fly {
  0% {
    right: -11vw;
    top: 53%;
    transform: scale(1);
  }
  36% {
    right: 5vw;
    top: 39%;
    transform: scale(0.8);
  }
  96% {
    right: 4vw;
    top: 2%;
    transform: scale(0.1);
  }
  to {
    right: 4vw;
    top: -5%;
    transform: scale(0);
  }
}

@keyframes lamp5-fly {
  0% {
    right: -12vw;
    top: 53%;
    transform: scale(0.6);
  }
  to {
    right: 34vw;
    top: -5%;
    transform: scale(0);
  }
}

@keyframes lamp6-fly {
  0% {
    left: -11vw;
    top: 63%;
    transform: scale(0.7) rotate(20deg);
  }
  to {
    left: 34vw;
    top: -5%;
    transform: scale(0) rotate(20deg);
  }
}

@keyframes lamp7-fly {
  0% {
    left: -12vw;
    top: 69%;
    transform: scale(1) rotate(23deg);
  }
  26% {
    left: 8vw;
    top: 58%;
    transform: scale(0.78) rotate(23deg);
  }
  95% {
    left: 13vw;
    top: 0;
    transform: scale(0.1) rotate(23deg);
  }
  to {
    left: 13vw;
    top: -5%;
    transform: scale(0) rotate(23deg);
  }
}

@keyframes lamp8-fly {
  0% {
    left: -9vw;
    top: 60%;
    transform: scale(1) rotate(13deg);
  }
  38% {
    left: 15vw;
    top: 48%;
    transform: scale(0.78) rotate(13deg);
  }
  96% {
    left: 20vw;
    top: 0;
    transform: scale(0.1) rotate(13deg);
  }
  to {
    left: 20vw;
    top: -5%;
    transform: scale(0) rotate(13deg);
  }
}

@keyframes lamp9-fly {
  0% {
    left: -9vw;
    top: 64%;
    transform: scale(1) rotate(22deg);
  }
  45% {
    left: 29vw;
    top: 52%;
    transform: scale(0.83) rotate(22deg);
  }
  98% {
    left: 34vw;
    top: -1%;
    transform: scale(0.2) rotate(22deg);
  }
  to {
    left: 34vw;
    top: -5%;
    transform: scale(0) rotate(22deg);
  }
}

@keyframes lamp10-fly {
  0% {
    left: -9vw;
    top: 63%;
    transform: scale(1) rotate(18deg);
  }
  38% {
    left: 13vw;
    top: 56%;
    transform: scale(0.8) rotate(18deg);
  }
  99% {
    left: 25vw;
    top: -1%;
    transform: scale(0.2) rotate(18deg);
  }
  to {
    left: 25vw;
    top: -5%;
    transform: scale(0) rotate(18deg);
  }
}

@keyframes lamp11-fly {
  0% {
    left: -9vw;
    top: 59%;
    transform: scale(1) rotate(15deg);
  }
  40% {
    left: 44vw;
    top: 47%;
    transform: scale(0.8) rotate(15deg);
  }
  98% {
    left: 46vw;
    top: -2%;
    transform: scale(0.1) rotate(15deg);
  }
  to {
    left: 25vw;
    top: -5%;
    transform: scale(0) rotate(15deg);
  }
}

@keyframes lamp12-fly {
  0% {
    right: -9vw;
    top: 55%;
    transform: scale(1);
  }
  55% {
    right: 39vw;
    top: 36%;
    transform: scale(0.75);
  }
  97% {
    right: 41vw;
    top: 1%;
    transform: scale(0.1);
  }
  to {
    right: 14vw;
    top: -5%;
    transform: scale(0);
  }
}

.river-lamp-wrap .lamp-type1 {
  width: 49px;
  height: 54px;
  background: url(../../assets/jnt/jntbg/2/2.png) no-repeat;
  background-size: 100% 100%;
}

.river-lamp-wrap .lamp-type2 {
  width: 75px;
  height: 80.5px;
  background: url(../../assets/jnt/jntbg/2/1.png) no-repeat;
  background-size: 100% 100%;
}

.river-lamp-wrap .river-lamp-item {
  position: absolute;
  left: 18vw;
  bottom: -88px;
  opacity: 0.8;
}

.river-lamp-wrap .river-lamp-item:first-child {
  animation: lamp1-move-total 78s ease-in 1s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(2) {
  animation: lamp2-move-total 78s ease-in 10s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(3) {
  animation: lamp3-move-total 78s ease-in 19s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(4) {
  animation: lamp4-move-total 78s ease-in 30s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(5) {
  animation: lamp5-move-total 78s ease-in 41s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(6) {
  animation: lamp2-move-total 78s ease-in 52s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(7) {
  animation: lamp1-move-total 78s ease-in 63s infinite;
}

.river-lamp-wrap .river-lamp-item:nth-child(8) {
  animation: lamp4-move-total 78s ease-in 70s infinite;
}

@keyframes lamp1-move1 {
  0% {
    left: 18vw;
    bottom: -55px;
    transform: scale(1);
  }
  to {
    left: 60vw;
    bottom: 0;
    transform: scale(0.95);
  }
}

@keyframes lamp1-move2 {
  0% {
    left: 60vw;
    bottom: 0;
    transform: scale(0.95);
  }
  to {
    left: 24vw;
    bottom: 22px;
    transform: scale(0.9);
  }
}

@keyframes lamp1-move3 {
  0% {
    left: 24vw;
    bottom: 22px;
    transform: scale(0.9);
  }
  to {
    left: 74vw;
    bottom: 74px;
    transform: scale(0.8);
  }
}

@keyframes lamp1-move4 {
  0% {
    left: 74vw;
    bottom: 74px;
    transform: scale(0.8);
  }
  to {
    left: 30vw;
    bottom: 79px;
    transform: scale(0.7);
  }
}

@keyframes lamp1-move5 {
  0% {
    left: 30vw;
    bottom: 79px;
    transform: scale(0.7);
  }
  to {
    left: 66vw;
    bottom: 110px;
    transform: scale(0.6);
  }
}

@keyframes lamp1-move6 {
  0% {
    left: 66vw;
    bottom: 110px;
    transform: scale(0.6);
  }
  to {
    left: 34vw;
    bottom: 137px;
    transform: scale(0.5);
  }
}

@keyframes lamp1-move7 {
  0% {
    left: 34vw;
    bottom: 137px;
    transform: scale(0.5);
  }
  to {
    left: 48vw;
    bottom: 169px;
    transform: scale(0.4);
  }
}

@keyframes lamp1-move8 {
  0% {
    left: 48vw;
    bottom: 169px;
    transform: scale(0.4);
  }
  to {
    left: 26vw;
    bottom: 185px;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes lamp1-move-total {
  0% {
    left: 18vw;
    bottom: -55px;
    transform: scale(1);
  }
  8% {
    left: 60vw;
    bottom: 0;
    transform: scale(0.95);
  }
  18.33% {
    left: 18vw;
    bottom: 22px;
    transform: scale(0.9);
  }
  31.66% {
    left: 74vw;
    bottom: 74px;
    transform: scale(0.8);
  }
  43.33% {
    left: 18vw;
    bottom: 79px;
    transform: scale(0.7);
  }
  55% {
    left: 66vw;
    bottom: 110px;
    transform: scale(0.6);
  }
  68.33% {
    left: 24vw;
    bottom: 137px;
    transform: scale(0.5);
  }
  83.33% {
    left: 48vw;
    bottom: 150px;
    transform: scale(0.4);
  }
  99% {
    opacity: 1;
  }
  to {
    left: 26vw;
    bottom: 185px;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes lamp2-move-total {
  0% {
    left: 19vw;
    bottom: -60px;
    transform: scale(1);
  }
  9% {
    left: 50vw;
    bottom: 0;
    transform: scale(0.95);
  }
  18% {
    left: 18vw;
    bottom: 26px;
    transform: scale(0.9);
  }
  30% {
    left: 71vw;
    bottom: 72px;
    transform: scale(0.8);
  }
  40% {
    left: 16vw;
    bottom: 80px;
    transform: scale(0.7);
  }
  55% {
    left: 65vw;
    bottom: 120px;
    transform: scale(0.6);
  }
  69% {
    left: 19vw;
    bottom: 147px;
    transform: scale(0.5);
  }
  84% {
    left: 49vw;
    bottom: 177px;
    transform: scale(0.4);
  }
  99% {
    opacity: 1;
  }
  to {
    left: 23vw;
    bottom: 170px;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes lamp3-move-total {
  0% {
    left: 17vw;
    bottom: -70px;
    transform: scale(1);
  }
  9% {
    left: 55vw;
    bottom: 10px;
    transform: scale(0.9);
  }
  18% {
    left: 20vw;
    bottom: 26px;
    transform: scale(0.8);
  }
  30% {
    left: 70vw;
    bottom: 70px;
    transform: scale(0.7);
  }
  40% {
    left: 20vw;
    bottom: 85px;
    transform: scale(0.6);
  }
  55% {
    left: 65vw;
    bottom: 121px;
    transform: scale(0.5);
  }
  69% {
    left: 22vw;
    bottom: 147px;
    transform: scale(0.4);
  }
  84% {
    left: 46vw;
    bottom: 170px;
    transform: scale(0.3);
  }
  99% {
    opacity: 1;
  }
  to {
    left: 22vw;
    bottom: 155px;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes lamp4-move-total {
  0% {
    left: 18vw;
    bottom: -60px;
    transform: scale(1);
  }
  9% {
    left: 58vw;
    bottom: 8px;
    transform: scale(0.9);
  }
  18% {
    left: 20vw;
    bottom: 26px;
    transform: scale(0.8);
  }
  30% {
    left: 66vw;
    bottom: 66px;
    transform: scale(0.7);
  }
  40% {
    left: 19vw;
    bottom: 80px;
    transform: scale(0.6);
  }
  55% {
    left: 62vw;
    bottom: 110px;
    transform: scale(0.5);
  }
  69% {
    left: 19vw;
    bottom: 150px;
    transform: scale(0.4);
  }
  84% {
    left: 47vw;
    bottom: 160px;
    transform: scale(0.3);
  }
  99% {
    opacity: 1;
  }
  to {
    left: 21vw;
    bottom: 160px;
    transform: scale(0);
    opacity: 0;
  }
}

@keyframes lamp5-move-total {
  0% {
    left: 20vw;
    bottom: -55px;
    transform: scale(1);
  }
  8.33% {
    left: 60vw;
    bottom: 5px;
    transform: scale(0.95);
  }
  18.33% {
    left: 21vw;
    bottom: 20px;
    transform: scale(0.9);
  }
  31.66% {
    left: 73vw;
    bottom: 70px;
    transform: scale(0.8);
  }
  43.33% {
    left: 23vw;
    bottom: 75px;
    transform: scale(0.7);
  }
  55% {
    left: 66vw;
    bottom: 105px;
    transform: scale(0.6);
  }
  68.33% {
    left: 30vw;
    bottom: 130px;
    transform: scale(0.5);
  }
  83.33% {
    left: 46vw;
    bottom: 145px;
    transform: scale(0.4);
  }
  99% {
    opacity: 1;
  }
  to {
    left: 28vw;
    bottom: 165px;
    transform: scale(0);
    opacity: 0;
  }
}
/* 3 */
.autumn-wrap {
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.autumn-wrap,
.autumn-wrap .leaf {
  position: absolute;
}

.autumn-wrap .leaf-type1 {
  opacity: 0;
  width: 28px;
  height: 20px;
  background: url(../../assets/jnt/jntbg/3/2.png) no-repeat;
  background-size: 100% 100%;
}

.autumn-wrap .leaf-type2 {
  opacity: 0;
  width: 30px;
  height: 18.5px;
  background: url(../../assets/jnt/jntbg/3/1.png) no-repeat;
  background-size: 100% 100%;
}

.autumn-wrap .leaf:first-child {
  right: 100px;
  top: 20px;
  animation: ani-down1 9.5s ease-in-out 1.5s infinite;
}

.autumn-wrap .leaf:nth-child(2) {
  right: 70px;
  top: 30px;
  animation: ani-down2 9s ease-in-out 2s infinite;
}

.autumn-wrap .leaf:nth-child(3) {
  right: 40px;
  top: 50px;
  animation: ani-down3 9.4s ease-in-out 2.5s infinite;
}

.autumn-wrap .leaf:nth-child(4) {
  right: 20px;
  top: 70px;
  animation: ani-down4 9.2s ease-in-out 3s infinite;
}

.autumn-wrap .leaf:nth-child(5) {
  right: -10px;
  top: 100px;
  animation: ani-down5 9.5s ease-in-out 5s infinite;
}

.autumn-wrap .leaf:nth-child(6) {
  right: -40px;
  top: 140px;
  animation: ani-down6 9.3s ease-in-out 4.5s infinite;
}

.autumn-wrap .leaf:nth-child(7) {
  right: 0;
  top: 0;
  animation: ani-down7 9.7s ease-in-out 4.7s infinite;
}

.autumn-wrap .leaf:nth-child(8) {
  right: 0;
  top: 0;
  animation: ani-down8 9.3s ease-in-out 5.5s infinite;
}

.autumn-wrap .leaf:nth-child(9) {
  right: 0;
  top: 0;
  animation: ani-down9 8.6s ease-in-out 6.3s infinite;
}

.autumn-wrap .leaf:nth-child(10) {
  right: 0;
  top: 0;
  animation: ani-down10 9.3s ease-in-out 7s infinite;
}

.autumn-wrap .leaf:nth-child(11) {
  right: -70px;
  top: 0;
  animation: ani-down11 8.7s ease-in-out 4.8s infinite;
}

.autumn-wrap .leaf:nth-child(12) {
  right: -90px;
  top: 50px;
  animation: ani-down12 9.3s ease-in-out 5.5s infinite;
}

.autumn-wrap .leaf:nth-child(13) {
  right: 80px;
  top: 35px;
  animation: ani-down2 9.4s ease-in-out 7s infinite;
}

.autumn-wrap .leaf:nth-child(14) {
  right: 90px;
  top: 50px;
  animation: ani-down4 9.7s ease-in-out 7.2s infinite;
}

.autumn-wrap .leaf:nth-child(15) {
  right: -30px;
  top: 125px;
  animation: ani-down6 9.5s ease-in-out 8.2s infinite;
}

.autumn-wrap .leaf:nth-child(16) {
  right: -85px;
  top: 45px;
  animation: ani-down12 9.4s ease-in-out 8.5s infinite;
}

@keyframes ani-down1 {
  0% {
    opacity: 1;
    right: 70px;
    top: -20px;
    transform: rotate(45deg);
  }
  25% {
    opacity: 1;
    transform: rotate(1deg);
  }
  50% {
    opacity: 1;
    transform: rotate(50deg);
  }
  75% {
    opacity: 0.9;
    transform: rotate(5deg);
  }
  to {
    opacity: 0;
    right: 500px;
    top: 600px;
    transform: rotate(55deg);
  }
}

@keyframes ani-down2 {
  0% {
    opacity: 1;
    right: 55px;
    top: -30px;
    transform: rotate(-70deg);
  }
  25% {
    opacity: 1;
    transform: rotate(-155deg);
  }
  50% {
    opacity: 1;
    transform: rotate(-100deg);
  }
  75% {
    opacity: 0.9;
    transform: rotate(-150deg);
  }
  to {
    opacity: 0;
    right: 450px;
    top: 620px;
    transform: rotate(-90deg);
  }
}

@keyframes ani-down3 {
  0% {
    opacity: 1;
    right: 40px;
    top: 0;
    transform: rotate(0deg);
  }
  25% {
    opacity: 1;
    transform: rotate(75deg);
  }
  50% {
    opacity: 1;
    transform: rotate(130deg);
  }
  75% {
    opacity: 0.9;
    transform: rotate(70deg);
  }
  to {
    opacity: 0;
    right: 350px;
    top: 600px;
    transform: rotate(120deg);
  }
}

@keyframes ani-down4 {
  0% {
    opacity: 1;
    right: 30px;
    top: -25px;
    transform: rotate(180deg);
  }
  30% {
    opacity: 1;
    transform: rotate(270deg);
  }
  50% {
    opacity: 1;
    transform: rotate(180deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(270deg);
  }
  to {
    opacity: 0;
    right: 390px;
    top: 650px;
    transform: rotate(180deg);
  }
}

@keyframes ani-down5 {
  0% {
    opacity: 1;
    right: 15px;
    top: -21px;
    transform: rotate(0deg);
  }
  20% {
    opacity: 1;
    transform: rotate(120deg);
  }
  40% {
    opacity: 1;
    transform: rotate(55deg);
  }
  60% {
    opacity: 1;
    transform: rotate(120deg);
  }
  80% {
    opacity: 0.9;
    transform: rotate(60deg);
  }
  to {
    opacity: 0;
    right: 240px;
    top: 700px;
    transform: rotate(110deg);
  }
}

@keyframes ani-down6 {
  0% {
    opacity: 1;
    right: -20px;
    top: -14px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 170px;
    top: 750px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down7 {
  0% {
    opacity: 1;
    right: -60px;
    top: 120px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 470px;
    top: 700px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down8 {
  0% {
    opacity: 1;
    right: -30px;
    top: 130px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 400px;
    top: 660px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down9 {
  0% {
    opacity: 1;
    right: -20px;
    top: 110px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 340px;
    top: 660px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down10 {
  0% {
    opacity: 1;
    right: -31px;
    top: 90px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 260px;
    top: 660px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down11 {
  0% {
    opacity: 1;
    right: -70px;
    top: 0;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 200px;
    top: 660px;
    transform: rotate(1deg);
  }
}

@keyframes ani-down12 {
  0% {
    opacity: 1;
    right: -30px;
    top: 25px;
    transform: rotate(0deg);
  }
  30% {
    opacity: 1;
    transform: rotate(35deg);
  }
  50% {
    opacity: 1;
    transform: rotate(5deg);
  }
  70% {
    opacity: 0.9;
    transform: rotate(45deg);
  }
  to {
    opacity: 0;
    right: 360px;
    top: 660px;
    transform: rotate(1deg);
  }
}

/* 3 */
/* 4 */
.duanwu-leaf {
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.duanwu-leaf,
.duanwu-leaf .leaf {
  position: absolute;
}

.duanwu-leaf .leaf-type1 {
  opacity: 0;
  width: 22px;
  height: 10px;
  background: url(../../assets/jnt/jntbg/4/8.png) no-repeat;
  background-size: 100% 100%;
}

.duanwu-leaf .leaf-type2 {
  opacity: 0;
  width: 26px;
  height: 18px;
  background: url(../../assets/jnt/jntbg/4/9.png) no-repeat;
  background-size: 100% 100%;
}

.duanwu-leaf .leaf:first-child {
  right: 100px;
  top: 20px;
  animation: ani-down1 7.5s ease-in-out 1.5s infinite;
}

.duanwu-leaf .leaf:nth-child(2) {
  right: 70px;
  top: 30px;
  animation: ani-down2 7.5s ease-in-out 2s infinite;
}

.duanwu-leaf .leaf:nth-child(3) {
  right: 40px;
  top: 50px;
  animation: ani-down3 7.5s ease-in-out 2.5s infinite;
}

.duanwu-leaf .leaf:nth-child(4) {
  right: 20px;
  top: 70px;
  animation: ani-down4 7.5s ease-in-out 3s infinite;
}

.duanwu-leaf .leaf:nth-child(5) {
  right: -10px;
  top: 100px;
  animation: ani-down5 7.5s ease-in-out 5s infinite;
}

.duanwu-leaf .leaf:nth-child(6) {
  right: -40px;
  top: 140px;
  animation: ani-down6 7.5s ease-in-out 4.5s infinite;
}

.duanwu-leaf .leaf:nth-child(7) {
  right: 0;
  top: 0;
  animation: ani-down7 7.7s ease-in-out 4.7s infinite;
}

.duanwu-leaf .leaf:nth-child(8) {
  right: 0;
  top: 0;
  animation: ani-down8 7.3s ease-in-out 5.5s infinite;
}

.duanwu-leaf .leaf:nth-child(9) {
  right: 0;
  top: 0;
  animation: ani-down9 7.5s ease-in-out 6.3s infinite;
}

.duanwu-leaf .leaf:nth-child(10) {
  right: 0;
  top: 0;
  animation: ani-down10 7.3s ease-in-out 7s infinite;
}

.duanwu-leaf .leaf:nth-child(11) {
  right: -70px;
  top: 0;
  animation: ani-down11 6.3s ease-in-out 4.8s infinite;
}

.duanwu-leaf .leaf:nth-child(12) {
  right: -90px;
  top: 50px;
  animation: ani-down12 7.3s ease-in-out 5.5s infinite;
}

.duanwu-leaf .leaf:nth-child(13) {
  right: 80px;
  top: 35px;
  animation: ani-down2 7.4s ease-in-out 7s infinite;
}

.duanwu-leaf .leaf:nth-child(14) {
  right: 90px;
  top: 50px;
  animation: ani-down4 7.7s ease-in-out 7.2s infinite;
}

.duanwu-leaf .leaf:nth-child(15) {
  right: -30px;
  top: 125px;
  animation: ani-down6 7.5s ease-in-out 8.2s infinite;
}

.duanwu-leaf .leaf:nth-child(16) {
  right: -85px;
  top: 45px;
  animation: ani-down12 7.3s ease-in-out 8.5s infinite;
}

/* 4 */
/* 5 */
.summer-wrap .sum-leaf {
  position: absolute;
  right: -1rem;
  top: -2rem;
  width: 10.14rem;
  animation: leaf-shake 8s ease-in-out 1s infinite;
  transform-origin: right bottom;
}

@keyframes leaf-shake {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(8deg);
  }
  to {
    transform: rotate(0deg);
  }
}

.summer-wrap .sum-boat {
  width: 10.64rem;
  position: absolute;
  left: -10.64rem;
  bottom: 15.45rem;
  z-index: 5;
  animation: sum-boat 48s linear 0s infinite;
  -webkit-animation: sum-boat 48s linear 0s infinite;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg);
}

.summer-wrap .sum-boat img,
.summer-wrap .sum-leaf img {
  width: 100%;
}

@keyframes sum-boat {
  0% {
    left: -10.64rem;
    transform: rotateY(180deg);
  }
  49.99% {
    transform: rotateY(180deg);
  }
  50% {
    left: 13rem;
    transform: rotateY(0deg);
  }
  to {
    left: -10.64rem;
    transform: rotateY(0deg);
  }
}

/* 5 */
/* 6 */
.winter-wrap .snow-item {
  position: absolute;
  opacity: 0;
}

.winter-wrap .small-snow .snow-item:first-child {
  width: 1.4rem;
  height: 1.4rem;
  left: 100px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/1.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 8.15s linear 1s infinite, ani-right-move1 8.15s linear 1s infinite;
  -webkit-animation: ani-down 8.15s linear 1s infinite, ani-right-move1 8.15s linear 1s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(2) {
  width: 1rem;
  height: 1.22rem;
  left: 40px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/2.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 5.55s linear 3.2s infinite;
  -webkit-animation: ani-down 5.55s linear 3.2s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(3) {
  width: 2.14rem;
  height: 2.4rem;
  left: 80px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/3.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 6s linear 0.8s infinite, ani-left-move1 6s 0.8s linear infinite;
  -webkit-animation: ani-down 6s linear 0.8s infinite, ani-left-move1 6s 0.8s linear infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(4) {
  width: 0.73rem;
  height: 1rem;
  left: 120px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/4.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 6.65s linear 4.9s infinite;
  -webkit-animation: ani-down 6.65s linear 4.9s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(5) {
  width: 1.73rem;
  height: 2rem;
  left: 160px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/5.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 7.35s linear 2.8s infinite;
  -webkit-animation: ani-down 7.35s linear 2.8s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(6) {
  width: 1rem;
  height: 1.22rem;
  background: url(../../assets/jnt/jntbg/6/6.png) no-repeat;
  background-size: 100% 100%;
  left: 330px;
  top: -30px;
  animation: ani-down 6.9s linear 2.6s infinite;
  -webkit-animation: ani-down 6.9s linear 2.6s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(7) {
  left: 280px;
  top: -30px;
  width: 2.14rem;
  height: 2.4rem;
  background: url(../../assets/jnt/jntbg/6/7.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 6.89s linear 3.4s infinite;
  -webkit-animation: ani-down 6.89s linear 3.4s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(8) {
  width: 1.73rem;
  height: 2rem;
  background: url(../../assets/jnt/jntbg/6/8.png) no-repeat;
  background-size: 100% 100%;
  left: 320px;
  top: -30px;
  animation: ani-down 6.49s linear 4s infinite, ani-left-move2 6.49s linear 4s infinite;
  -webkit-animation: ani-down 6.49s linear 4s infinite, ani-left-move2 6.49s linear 4s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(9) {
  left: 220px;
  top: -30px;
  width: 0.73rem;
  height: 1rem;
  background: url(../../assets/jnt/jntbg/6/9.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 6.25s linear 1.3s infinite;
  -webkit-animation: ani-down 6.25s linear 1.3s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(10) {
  width: 1.2rem;
  height: 1.2rem;
  left: 220px;
  animation: ani-down 6.25s linear 3.3s infinite, ani-right-move1 6.25s linear 3.3s infinite;
  -webkit-animation: ani-down 6.25s linear 3.3s infinite, ani-right-move1 6.25s linear 3.3s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(10),
.winter-wrap .small-snow .snow-item:nth-child(11) {
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/10.png) no-repeat;
  background-size: 100% 100%;
}

.winter-wrap .small-snow .snow-item:nth-child(11) {
  width: 1.5rem;
  height: 1.5rem;
  left: 120px;
  animation: ani-down 6.65s linear 5.6s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(12) {
  width: 1.3rem;
  height: 1.3rem;
  left: 170px;
  top: -30px;
  background: url(../../assets/jnt/jntbg/6/11.png) no-repeat;
  background-size: 100% 100%;
  animation: ani-down 7.4s linear 8.3s infinite;
  -webkit-animation: ani-down 7.4s linear 8.3s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(13) {
  width: 1.2rem;
  height: 1.2rem;
  left: 340px;
  animation: ani-down 5.7s linear 4.8s infinite;
}

.winter-wrap .small-snow .snow-item:nth-child(13),
.winter-wrap .small-snow .snow-item:nth-child(14) {
  top: 60px;
  background: url(../../assets/jnt/jntbg/6/12.png) no-repeat;
  background-size: 100% 100%;
}

.winter-wrap .small-snow .snow-item:nth-child(14) {
  width: 1.3rem;
  height: 1.3rem;
  right: 0;
  animation: ani-down 4.7s linear 0.8s infinite, ani-left-move3 4.7s linear 0.8s infinite;
  -webkit-animation: ani-down 4.7s linear 0.8s infinite, ani-left-move3 4.7s linear 0.8s infinite;
}

.winter-wrap .big-snow .snow-item {
  width: 2.272rem;
  height: 2.45rem;
  background: url(../../assets/jnt/jntbg/6/13.png) no-repeat;
  background-size: 100% 100%;
  opacity: 0;
}

.winter-wrap .big-snow .snow-item:first-child {
  left: 260px;
  top: -30px;
  transform: scale(0.6);
  -webkit-transform: scale(0.6);
  animation: ani-down 6.29s linear 8.3s infinite;
  -webkit-animation: ani-down 6.29s linear 8.3s infinite;
}

.winter-wrap .big-snow .snow-item:nth-child(2) {
  left: 60px;
  top: -30px;
  transform: scale(0.8);
  -webkit-transform: scale(0.8);
  animation: ani-down 6.1s linear 4.1s infinite;
  -webkit-animation: ani-down 6.1s linear 4.1s infinite;
}

.winter-wrap .big-snow .snow-item:nth-child(3) {
  left: 180px;
  top: -30px;
  transform: scale(0.75);
  -webkit-transform: scale(0.75);
  animation: ani-down 7.39s linear 5.1s infinite;
  -webkit-animation: ani-down 7.39s linear 5.1s infinite;
}

.winter-wrap .big-snow .snow-item:nth-child(4) {
  left: 120px;
  top: -30px;
  transform: scale(0.65);
  -webkit-transform: scale(0.65);
  animation: ani-down 7.79s linear 2.7s infinite, ani-right-move1 7.79s linear 2.7s infinite;
  -webkit-animation: ani-down 7.79s linear 2.7s infinite, ani-right-move1 7.79s linear 2.7s infinite;
}
/* 6 */

/* 单个祭品 */
.iframe-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  opacity: 1;
  z-index: 999;
  display: flex;
  align-items: center;
}

.iframe-box .iframe-img {
  width: 120px;
  height: 120px;
  z-index: 999;
  margin: 0 auto;
  line-height: 120px;
  text-align: center;
  animation: ani-scale 0.5s linear 0.5s;
  -webkit-animation: ani-scale 0.5s linear;
}

.iframe-img img {
  width: 100%;
  display: inline-block;
}
/* 单个祭品 */
.memory-right-nav .icon-pray-btn {
  background: linear-gradient(0deg, #d53d1a, #ffa531);
}
</style>
